import React from 'react';

// components
import AccountCard from './AccountCard';
import UpdatePasswordCard from './components/UpdatePasswordCard';
import PreferencesCard from './PreferencesCard';
import EmailIntegrationsCard from './EmailIntegrationsCard';
import DeleteAccountCard from './DeleteAccountCard';

const AccountSettings = function() {
  return (
    <>
      <AccountCard />
      <PreferencesCard />
      <UpdatePasswordCard />
      <EmailIntegrationsCard />
      <DeleteAccountCard />
    </>
  );
};

export default AccountSettings;
